__turbopack_context__.v({
  "className": "noto_sans_telugu_9c879c8d-module__cYfkVW__className",
});
